import { Button } from '@mui/material';
import { ButtonGroupField } from '../../ButtonGroupField';

const ButtonAnswerGroupType = ({ node, nodes, values, setFieldValue }) => {
    const handleAddOptionButton = (option_buttons, setFieldValue) => {
        if (!Array.isArray(option_buttons)) {
            option_buttons = [];
        }
        const optButtons = [...option_buttons];
        optButtons.push({
            action: {
                id: '',
                type: 'node',
            },
            button_id: Number(optButtons?.length),
            button_text: '',
            incorrect: false,
            answer_value: '',
        });
        setFieldValue('option_buttons', optButtons);
    };

    return (
        <>
            {values.option_buttons.length > 0 && (
                <ButtonGroupField
                    values={values}
                    setFieldValue={setFieldValue}
                    node={node}
                    nodes={nodes}
                ></ButtonGroupField>
            )}
            <Button
                sx={{ mt: 1 }}
                size="small"
                variant="contained"
                onClick={() => handleAddOptionButton(values?.option_buttons, setFieldValue)}
            >
                Add Button
            </Button>
        </>
    );
};

export default ButtonAnswerGroupType;
